// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"99411d94","213":"99e763bd","239":"a4248305","386":"4ca6b1d4","455":"84703210","913":"4ab4a724","914":"7eeeeebf"}[chunkId] + ".chunk.js";
};